
	  <mat-dialog-content class="mainDiv">
		  <h1 *ngIf="dialogTitle">{{dialogTitle}}</h1>
		  <h4 *ngIf="dialogMessage">{{dialogMessage}}</h4>
		  <div *ngIf="dialogHtml" class="dialogHtmlDiv" [innerHTML]="dialogHtml | safeHtml"></div>
		  <div class="buttons">
			  <button class="dialogButton" (click)="dialogRef.close()">{{dialogButtonName}}</button>
		  </div>
	  </mat-dialog-content>